/* eslint-disable react/prop-types */
import React from 'react';

const n = (v) => Number(v || 0).toLocaleString();

const formatAvgSleep = (minutes) => {
  const mins = Number(minutes) || 0;
  const h = Math.floor(mins / 60);
  const m = Math.round(mins % 60);
  return `${h}h ${m}m`;
};

// Detail summary cards: Total Sessions + Avg Sleep Duration (formatted "Xh Ym").
const SleepSummaryDetailSummaryCards = ({ totalSessions = 0, avgSleepMinutes = 0 }) => (
  <div className="au-cards" data-testid="ss-detail-summary">
    <div className="au-card">
      <span className="au-card__label">Total Sessions</span>
      <span className="au-card__value tnum">{n(totalSessions)}</span>
    </div>
    <div className="au-card">
      <span className="au-card__label">Avg Sleep Duration</span>
      <span className="au-card__value tnum" data-testid="ss-avg-sleep">{formatAvgSleep(avgSleepMinutes)}</span>
      <span className="au-card__def">Average nightly total across the selected range.</span>
    </div>
  </div>
);

export default SleepSummaryDetailSummaryCards;
